import React from 'react';
import { Link } from 'wouter';

const Footer: React.FC = () => {
  return (
    <footer className="bg-indigo-950 text-white py-12 px-4">
      <div className="max-w-6xl mx-auto grid grid-cols-1 md:grid-cols-4 gap-8">
        <div className="space-y-4">
          <h3 className="text-lg font-medium">Next Generation Medicine</h3>
          <p className="text-sm text-gray-300">
            Advancing the future of medicine through cutting-edge scientific research and clinical excellence.
          </p>
          <p className="text-sm text-gray-300">
            {new Date().getFullYear()} Next Generation Medicine. All rights reserved.
          </p>
        </div>
        
        <div>
          <h3 className="font-medium mb-4">Navigation</h3>
          <ul className="space-y-2 text-sm">
            <li><Link href="/consulting" className="hover:text-indigo-300 transition-colors">Consulting</Link></li>
            <li><Link href="/mentorship" className="hover:text-indigo-300 transition-colors">Mentorship</Link></li>
            <li><Link href="/patients" className="hover:text-indigo-300 transition-colors">Patients</Link></li>
          </ul>
        </div>
        
        <div>
          <h3 className="font-medium mb-4">Contact</h3>
          <ul className="space-y-2 text-sm">
            <li className="flex items-start">
              <span className="mr-2">📧</span>
              <a href="mailto:anant@nextgenerationmedicine.co" className="hover:text-indigo-300 transition-colors">anant@nextgenerationmedicine.co</a>
            </li>
            <li className="flex items-start">
              <span className="mr-2">🌐</span>
              <a href="https://nextgenerationmedicine.co" className="hover:text-indigo-300 transition-colors">nextgenerationmedicine.co</a>
            </li>
            {/* Removed San Francisco location */}
          </ul>
        </div>
      </div>
    </footer>
  );
};

export default Footer;